
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 90","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M90.609 0H9.215C4.205 0 0 4.317 0 9.643v70.714C0 85.683 4.205 90 9.215 90H90.61c5.186 0 9.391-4.317 9.391-9.643V9.643C100 4.317 95.97 0 90.609 0zM21.737 75.536c0 .887-.7 1.607-1.565 1.607h-9.391c-.865 0-1.566-.72-1.566-1.607v-9.643c0-.888.701-1.607 1.566-1.607h9.215c.864 0 1.565.72 1.565 1.607l.176 9.643zm0-25.715c0 .888-.7 1.608-1.565 1.608h-9.391c-.865 0-1.566-.72-1.566-1.608V40.18c0-.888.701-1.608 1.566-1.608h9.215c.864 0 1.565.72 1.565 1.608v9.642h.176zm0-25.714c0 .888-.7 1.607-1.565 1.607h-9.391c-.865 0-1.566-.72-1.566-1.607v-9.643c0-.887.701-1.607 1.566-1.607h9.215c.864 0 1.565.72 1.565 1.607l.176 9.643zM68.695 73.93c0 1.775-1.402 3.214-3.13 3.214H34.26c-1.73 0-3.131-1.44-3.131-3.214V54.643c0-1.776 1.402-3.214 3.13-3.214h31.305c1.73 0 3.131 1.438 3.131 3.214v19.286zm0-38.572c0 1.775-1.402 3.214-3.13 3.214H34.26c-1.73 0-3.131-1.439-3.131-3.214V16.071c0-1.775 1.402-3.214 3.13-3.214h31.305c1.73 0 3.131 1.439 3.131 3.214v19.286zm21.914 40.179c0 .887-.701 1.607-1.566 1.607h-9.215c-.865 0-1.39-.72-1.39-1.607v-9.643c0-.888.701-1.607 1.566-1.607h9.215c.865 0 1.566.72 1.566 1.607v9.643h-.176zm0-25.715c0 .888-.701 1.608-1.566 1.608h-9.215c-.865 0-1.565-.72-1.565-1.608V40.18c0-.888.7-1.608 1.565-1.608h9.215c.865 0 1.566.72 1.566 1.608v9.642zm0-25.714c0 .888-.701 1.607-1.566 1.607h-9.215c-.865 0-1.565-.72-1.565-1.607v-9.643c0-.887.7-1.607 1.389-1.607h9.215c.865 0 1.565.72 1.565 1.607v9.643h.177z","fill":"currentColor"}})])
          )
        }
      }
    